import {
  default as ClassicEditor,
  default as ClassicEditor2,
} from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../../App";
import useFileHandleS3 from "../../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../../Screen/MediaUploadProgressBar";

const AddProductFromMarketPlace = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [starId, setStarId] = useState("");
  const [category_id, setCategoryId] = useState("");
  const [subcategory_id, setSubcategoryId] = useState("");
  const [unit_price, setUnitprice] = useState("");
  const [total_items, setItems] = useState("");
  const [tax, setTax] = useState("");
  const [keywords, setKeywords] = useState("");
  const [starList, setStarList] = useState([]);
  const [subcategories, setSubcategory] = useState([]);
  const [categories, setCategory] = useState([]);
  const [errorList, setErrorList] = useState([]);


  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'marketplace/images', delKey);



  const changeHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };


  const selectState = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/fetch-subcategory/${data}`).then((res) => {
      if (res.status === 200) {
        setSubcategory(res.data.category);
      }
      //   setLoading(false);
    });

    setCategoryId(data);
  };



  // Fetch Stars Added By Admin
  useEffect(() => {
    // axios.get(`/api/admin/star_list`).then((res) => {
    // if (res.status === 200) {
    //     setStarList(res.data.category);
    // }
    // });
    axios.get(`/api/admin/view-category`).then((res) => {
      if (res.status === 200) {
        setCategory(res.data.category);
        setStarList(res.data.allStar);
      }
    });
  }, []);

  // let history = useHistory();

  const [convertedContent, setConvertedContent] = useState(null);
  const [convertedContent2, setConvertedContent2] = useState(null);

  useEffect(() => {
    setConvertedContent("");
    setConvertedContent2("");
  }, []);


  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const createMarketplace = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("title", title);
    formData.append("superstar_id", starId);
    formData.append("category_id", category_id);
    formData.append("subcategory_id", subcategory_id);
    formData.append("description", convertedContent);
    formData.append("terms_conditions", convertedContent2);
    // formData.append("delivery_charge", delivery_charge);
    formData.append("tax", tax);
    formData.append("unit_price", unit_price);
    formData.append("total_items", total_items);
    formData.append("keywords", keywords);
    formData.append("image", fileKey);

    axios.post(`/api/admin/marketplace/store`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setTitle("");
        setUnitprice("");
        setItems("");
        setKeywords("");

        swal("Welcome", res.data.message, "success");
        history.push("/superstar-admin/product-list/pending");

        socket.current.emit("marketplace_approve", {
          id: res.data.marketplaceId,
        });
      }
      if (res.data.status === 402) {
        setErrorList(res.data.errors);
      }
    });
  };

  return (
    <div className="AS">
      <div className="text-light mb-3 d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Add Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={createMarketplace}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Title</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={title}
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                        placeholder="Enter title"
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>
                        <>Select Super Star</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <select
                        onChange={(event) => {
                          setStarId(event.target.value);
                        }}
                        name="superstar_id"
                        value={starId}
                        className="form-control reply-control"
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList?.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">
                        {errorList.superstar_id}
                      </span>
                    </div>
                  </div>
                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>
                        <>Select Category</>
                      </p>
                    </div>
                    <div className="col-md-3">
                      <select
                        onChange={selectState}
                        name="category_id"
                        value={category_id}
                        className="form-control reply-control"
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {categories?.map((category, index) => (
                          <option className="text-black" value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">
                        {errorList.category_id}
                      </span>
                    </div>
                    <div className="col-md-3 label-text text-md-end">
                      <p>
                        <>Select Subcategory</>
                      </p>
                    </div>
                    <div className="col-md-3">
                      <select
                        onChange={(event) => {
                          setSubcategoryId(event.target.value);
                        }}
                        name="subcategory_id"
                        value={subcategory_id}
                        className="form-control reply-control"
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {subcategories.map((subcategory, index) => (
                          <option className="text-black" value={subcategory.id}>
                            {subcategory.name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">
                        {errorList.subcategory_id}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Keyword</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        placeholder="Enter keyword"
                        value={keywords}
                        onChange={(event) => {
                          setKeywords(event.target.value);
                        }}
                      />
                      <span className="text-danger">{errorList.keywords}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>
                        <>Terms & Conditions</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor2}
                        data={convertedContent2}
                        onReady={(editor) => {
                          // You can store the "editor" and use when it is needed.
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent2(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.terms_conditions}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>
                        <>Total Units</>
                      </p>
                    </div>
                    <div className="col-md-3">
                      <input
                        placeholder="Enter units"
                        type="number"
                        className="form-control reply-control"
                        value={total_items}
                        min={0}
                        onChange={(event) => {
                          setItems(event.target.value);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.total_items}
                      </span>
                    </div>
                    <div className="col-md-3 label-text label-text d-flex justify-content-end">
                      <p>
                        <>Price</>
                      </p>
                    </div>
                    <div className="col-md-3">
                      <input
                        placeholder="Enter price $"
                        type="number"
                        className="form-control reply-control"
                        value={unit_price}
                        min={0}
                        step=".01"
                        onChange={(event) => {
                          setUnitprice(event.target.value);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.unit_price}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text d-flex">
                      <p>
                        <>Tax</>
                      </p>
                    </div>
                    <div className="col-md-3">
                      <input
                        placeholder="Enter tax"
                        type="number"
                        className="form-control reply-control"
                        value={tax}
                        min={0}
                        onChange={(event) => {
                          setTax(event.target.value);
                        }}
                      />
                      <span className="text-danger">{errorList.tax}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Image</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid img-fluid"
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        onChange={(e) => changeHandler(e.target.files)}
                        accept="image/*"
                      />
                    {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger">{errorList.image}</span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductFromMarketPlace;
